<template>
    <div class="place_view_main">
        <div class="site">
            <div class="top">
                <div class="image">
                    <img :src="site.preview" :alt="site.name">
                </div>
                <div class="site-info__wrapper">
                    <div class="site-info">
                        <md-field>
                            <label>Site Name</label>
                            <md-input v-model="site.name" class="info-input"></md-input>
                        </md-field>
                        <md-field>
                            <label>Site Address</label>
                            <md-input v-model="site.address" class="info-input"></md-input>
                        </md-field>
                        <md-field>
                            <label>Site Email</label>
                            <md-input v-model="site.email"></md-input>
                        </md-field>
                        <span>Google id: {{site.id}}</span>
                    </div>
                    <div class="site-info">
                        <md-field>
                            <label>Site Phone</label>
                            <md-input v-model="site.phone"></md-input>
                        </md-field>
                        <md-field>
                            <label>Site Website</label>
                            <md-input v-model="site.website"></md-input>
                        </md-field>
                        <md-field>
                            <label>Site Short Tag</label>
                            <md-input v-model="site.short_tag"></md-input>
                        </md-field>
                        <span>UID: {{site.uid}}</span>
                    </div>
                </div>
            </div>
            <div class="save-info">
                <button class="primaryButton" @click="ChangeSiteInfo">
                    {{ translate('Save') }}
                </button>
            </div>
            <div class="bottom">
                <div class="social">
                    <div v-for="item in socialListArr"
                         :key="item.id"
                    class="social-container">
                        <md-field md-clearable>
                            <label>{{item.network_name}}</label>
                            <md-input
                                    v-model="item.model"
                                    type="text"
                            ></md-input>
                        </md-field>
                        <b-form-checkbox
                            v-model="item.enabled"
                        >
                        </b-form-checkbox>
                        <span>Enabled</span>
                    </div>
                    <button class="primaryButton" @click="saveSocial()">
                        {{ translate('Save') }}
                    </button>
                </div>
            </div>
        </div>
        <b-list-group>

            <b-list-group-item v-for="item in qrCodes" v-bind:key="item.index" v-b-toggle="item.index">
                <div class="left-list-side" @click="selectPlace(item.uid, 'edit', item.text, item.optional)">
                    <span>{{item.text}}</span>
                    <span>({{item.optional}})</span>
                </div>
                <div class="right-list-side">
                    <a class="print btn" :href="item.link" target="_blank">PDF</a>
                </div>
            </b-list-group-item>

            <p v-if="qrCodes.length == 0" class="statusMessage">{{statusMessage}}</p>

        </b-list-group>
        <pdf ref="pdf" :src="PDF_link"></pdf>


        <!--  Add  -->
        <b-modal v-model="showModal" content-class="custom-modal">
            <template v-slot:modal-header="{ close }">
                <span class="close-icon" @click="close"></span>
            </template>

            <md-field>
                <label>Question</label>
                <md-textarea
                        v-model="question"
                        type="text"
                        md-counter="100"
                ></md-textarea>
            </md-field>
            <md-field>
                <label>Location</label>
                <md-input
                        v-model="location"
                        type="text"
                ></md-input>
            </md-field>

            <template v-slot:modal-footer>
                <button class="primaryButton block" @click="AddQuestion">
                    {{ translate('admin_Add') }}
                </button>
            </template>

        </b-modal>

        <!--  Change  -->
        <b-modal v-model="showModalChange" content-class="custom-modal">
            <template v-slot:modal-header="{ close }">
                <span class="close-icon" @click="close"></span>
            </template>

            <md-field>
                <label>Question</label>
                <md-textarea
                        v-model="question"
                        type="text"
                        md-counter="100"
                ></md-textarea>
            </md-field>
            <md-field>
                <label>Location</label>
                <md-input
                        v-model="location"
                        type="text"
                ></md-input>
            </md-field>

            <template v-slot:modal-footer>
                <button class="primaryButton block reverse"
                        :disabled="loadingDelete"
                        @click="RemoveQuestion()">
                    <b-spinner v-if="loadingDelete" small></b-spinner>
                    {{ translate('admin_Delete') }}
                </button>
                <button class="primaryButton block"
                        :disabled="loadingUpdate"
                        @click="ChangeQuestion()">
                    <b-spinner v-if="loadingUpdate" small></b-spinner>
                    {{ translate('Save') }}
                </button>

            </template>

        </b-modal>

    </div>
</template>

<script>


    import errorMixin from '@/mixins/errorMixin';
    import pdf from 'vue-pdf'
    import {mapActions, mapState, mapGetters} from 'vuex';
    import config from '@/api/config';

    const {required, email} = require('vuelidate/lib/validators')
    import {phoneValidator, urlValidator} from '@/helpers/customValidators'
    import {validationMixin} from 'vuelidate'


    export default {
        mixins: [mixin, errorMixin, validationMixin],
        components: {
            pdf
        },
        validations: {
            socialList: {
                $each: {
                    model: {
                        url: urlValidator
                    }
                }
            }
        },
        data() {
            return {
                loadingUpdate: false,
                loadingDelete: false,
                unlinkedUID: '',
                showModalChange: false,
                statusMessage: this.translate('statusMessage'),
                place_id: this.$route.params.id,
                PDF_link: '',
                question: '',
                location: '',
                showModal: false,
                qrCodes: [],
                socialModal: false,
                socialListArr: [],
                site: []
            }
        },
        async mounted() {
            if (localStorage.getItem('access_token') == undefined) {
                this.$router.push('/sign-in');
                return false;
            } else {
                await this.getQuestions();
                await this.getSiteInfo();
            }
        },

        computed: {
            ...mapState({
                userInfo: state => state.auth.userInfo,
                socialList: state => state.auth.socialList
            }),

            ...mapGetters({
                getFormatedLang: 'getFormatedLang'
            })
        },

        watch: {
            getFormatedLang() {
                this.createPdfLink(this.qrCodes)
            },
            showModal(val) {
                if (val) {
                    this.question = '';
                    this.location = '';
                }
            }
        },

        methods: {
            ...mapActions({
                getQuestionsAction: 'question/getQuestions',
                createQuestion: 'question/createQuestion',
                updateQuestion: 'question/updateQuestion',
                deleteQuestion: 'question/deleteQuestion',
                addQuestionToPlace: 'question/addQuestionToPlace',
                saveSocialList: 'question/saveSocialList',
                getSiteInfoAction: 'question/getSiteInfo',
                updateSiteInfo: 'question/updateSiteInfo'
            }),

            mergeSocialList(val) {
                let list = val
                list.forEach(item => item.model = '')
                this.site.links.forEach((item, index) => {
                    list[list.map(item => item.id).indexOf(item.network.id)].model = item.url
                    list[list.map(item => item.id).indexOf(item.network.id)].enabled = item.enabled
                    console.log(list)
                })
                this.socialListArr = list
            },

            async getSiteInfo(){
                try {
                    const response = await this.getSiteInfoAction({
                        uid_site: this.place_id
                    })
                    this.$store.commit("auth/setSocialList", {
                        networks: response.networks
                    });
                    this.site = response.site
                    this.mergeSocialList(this.socialList)

                } catch (e) {
                    this.showErrorModal(e.data.error.message, {title: 'CancelRequest'})
                }
            },

            async saveSocial() {
                let data = {
                    links: []
                }
                this.socialListArr.forEach(item => {
                    data.links.push({
                        url: item.model,
                        enabled: item.enabled,
                        network_id: item.id
                    })
                })
                try {
                    const response = await this.saveSocialList({
                        data,
                        uid_site: this.place_id
                    })
                    console.log(response)
                    if (response.success) {
                        this.socialModal = false
                        this.$bvToast.toast(this.translate('savedSuccessfuly'), {
                            title: this.translate('Message'),
                            variant: 'success',
                            solid: true,
                            autoHideDelay: 1000
                        })
                    }
                } catch(e) {
                    this.showErrorModal(e.data.error.message, {title: 'CancelRequest'})
                }
            },

            async ChangeSiteInfo () {
                try {
                    const response = await this.updateSiteInfo({
                        data: {
                            name: this.site.name,
                            address: this.site.address,
                            short_tag: this.site.short_tag,
                            email: this.site.email,
                            phone: this.site.phone,
                            website: this.site.website
                        },
                        uid_site: this.place_id
                    })
                } catch (e) {
                    this.showErrorModal(e.data.error.message, {title: 'CancelRequest'})
                }
            },

            async AddQuestion() {
                const body = {
                    count: 1,
                    text: this.question,
                    optional: this.location,
                    place_id: this.place_id
                };

                const response = await this.addQuestionToPlace(body)
                if (response.success) {
                    this.question = '';
                    this.location = '';
                    this.showModal = false;
                    this.getQuestions();
                } else {
                    this.showErrorModal()
                }
            },
            PDF_print(link, name) {
                // browser.downloads.download({
                //   url : link,
                //   filename : name + '.pdf',
                //   conflictAction : 'uniquify'
                // })
                // this.PDF_link = link
                // pdf.createLoadingTask(link)
                // this.$refs.pdf.print();
            },

            createPdfLink() {
                for (var i = 0; this.qrCodes.length > i; i++) {
                    const link = `${config.baseUrl}/admin/questions/${this.qrCodes[i].uid}/pdf?language=${this.getFormatedLang}`
                    this.$set(this.qrCodes[i], 'link', link)
                }
            },

            async getQuestions() {
                let url = `/admin/questions?place_id=${this.place_id}`;
                try {
                    const response = await this.getQuestionsAction(url)
                    if (response.success) {
                        this.qrCodes = response.qrs;
                        if (this.qrCodes.length != 0) {
                            this.createPdfLink()
                        } else {
                            this.statusMessage = this.translate('admin_NothingFound');
                        }
                    } else {
                        this.showErrorModal()
                    }
                } catch (e) {
                    this.showErrorModal(e.data.error.message, {title: 'CancelRequest'})
                }

            },
            selectPlace(uid, choose, question, location) {
                console.log(uid)
                this.unlinkedUID = uid;
                this.showModalChange = true;
                this.question = question;
                this.location = location;
            },

            async ChangeQuestion() {
                const body = {
                    text: this.question,
                    optional: this.location
                };

                this.loadingUpdate = true
                try {
                    const response = await this.updateQuestion({
                        questionId: this.unlinkedUID,
                        body
                    })
                    this.loadingUpdate = false
                    if (response.success) {
                        this.getQuestions();
                    } else {
                        this.showErrorModal()
                    }
                } catch (e) {
                    this.loadingUpdate = false
                }

            },

            async RemoveQuestion() {
                this.loadingDelete = true
                const response = await this.deleteQuestion({
                    questionId: this.unlinkedUID
                })
                this.loadingDelete = false

                if (response.success) {
                    this.question = '';
                    this.location = '';
                    this.showModalChange = false;
                    this.getQuestions();
                } else {
                    this.showErrorModal()
                }
            },
        }
    }
</script>


<style scoped>

.place_view_main {
    max-height: calc(100vh - 70px);
    overflow: scroll;
    position: relative;
}
    .site {
        padding: 15px;
    }
    .site-info__wrapper {
        display: flex;
    }
    .site-info {
        width: 450px;
        margin: 0 35px;
    }
    .site-info__secondary {
        display: flex;
        flex-direction: column;
    }
    .bottom {
        max-width: 800px;
    }

    .site .top {
        display: flex;
        flex-direction: row;
        margin-bottom: 15px;
    }
    .md-field {
        margin: 4px 0 15px;
    }

    .add-qr {
        position: fixed;
        bottom: 1em;
        left: 50%;
        transform: translateX(-50%);
        width: 90%;
    }

    .list-group + span {
        display: none !important;
    }

    .list-group-item > * {
        margin-top: 1em;
    }

    .list-group-item > div > * {
        max-width: 40vw;
        padding: .3em 5vw;
    }


    .face-container-add {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(0, 0, 0, .6);
        z-index: 9 !important;
    }

    .face-container-add.white ul {
        background: #fff;
        display: flex;
    }

    .face-container-add ul {
        position: relative;
        margin: 0;
        padding: 1.3em 0;
        border-radius: 1em;
        flex-direction: column;
    }

    .face-container-add.white ul li {
        margin-bottom: .7em;
        display: flex;
        flex-direction: column;
    }

    .face-container-add.white ul li:last-child button {
        margin-top: 1em;
    }

    .face-container-add.white ul li img {
        width: 100%;
    }

    .face-container-add ul li.close {
        width: 1.4em;
        height: 1.4em;
        position: absolute;
        top: 0;
        right: 0em;
        z-index: 100;
    }

    .face-container-add ul li.close button {
        width: 2em;
        height: 2em;
        background: none;
        border: 0;
        outline: none;
    }

    .face-container-add ul li.close button:before,
    .face-container-add ul li.close button:after {
        content: '';
        position: absolute;
        width: 100%;
        height: .1em;
        background: #2F2F2F !important;
        border-radius: .2em;
        border: 0;
        background: 0;
        left: 0;
    }

    .face-container-add ul li.close button:before {
        transform: rotate(45deg);
    }

    .face-container-add ul li.close button:after {
        transform: rotate(-45deg);
    }

    .list-group-item {
        display: flex;
        flex-direction: row;
        padding: 0.35rem 1rem;
    }

    .list-group-item > * {
        margin: 0;
    }

    .list-group-item .left-list-side {
        display: flex;
        flex-direction: column;
        width: 100%;
    }

    .list-group-item .left-list-side span {
        width: 100%;
        display: inline-block;
        max-width: 100%;
        padding: 0;
    }

    .list-group-item .right-list-side {
        display: flex;
        align-items: center;
    }

    .list-group-item .right-list-side img {
        width: 2em;
        padding: 0;
    }

    .statusMessage {
        /*position: absolute;*/
        /*top: 50%;*/
        /*left: 50%;*/
        /*transform: translate(-50%);*/
        width: 100%;
        text-align: center;
    }

    a.print.btn {
        padding-right: 0 !important;
        outline: none;
        box-shadow: none;
    }

    .social-container {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    @media screen and (max-width: 1000px) {
        .face-container-add ul {
            min-width: 90vw;
        }
    }
    @media screen and (max-width: 1216px) {
        .site-info {
            margin: 0 20px;
        }
    }
    @media screen and (max-width: 1024px) {
        .site-info__wrapper {
            display: flex;
            flex-direction: column;
        }
        .save-info {
            margin-left: 220px;
        }
        .md-field {
            margin: 10px 0 15px;
        }

    }
    @media screen and (max-width: 426px) {
        .site-info {
            width: 380px;
            margin: 0;
        }
        .site .top {
            display: flex;
            flex-direction: column;
        }
        img {
            width: 160px !important;
        }
        .save-info {
            margin-left: 0;
        }
    }

    @media screen and (max-width: 375px) {
        .site-info {
            width: 350px;
        }
    }

    @media screen and (max-width: 320px) {
        .site-info {
            width: 300px;
        }
    }

</style>
